import { BarChart, Bar, XAxis,YAxis, CartesianGrid, Tooltip, Legend  } from 'recharts';
import type { Fond } from '../../types/Fond';
import { useFondByIdQuery } from '../../stores/OkOkStore';
import type { Transactions } from '../../types/Transaction';
import { useTrads } from "../../contexts/trads/useTrads";

function FondPersoBarChart({fond}:{fond:Fond}){
    const { data, error, isLoading } = useFondByIdQuery(fond.id.toString());

    const positifs=data?.transactions?.filter((e:Transactions)=>e.montant > 0).reduce((acc:number,e:Transactions)=>acc+e.montant,0)??0;
    const negatifs=data?.transactions?.filter((e:Transactions)=>e.montant < 0).reduce((acc:number,e:Transactions)=>acc+e.montant,0)??0;
    const {translate}=useTrads();
   
    const chartdata=[];
    const chartbar:Record<string,number|string>={
            name:fond.name,
            disponible:Math.round(((positifs + negatifs) * 100) ) / 100,
            sortie:-1* negatifs,
            pending:fond.pending,
            real:fond.real,
        }
    let aide_recue=0;
    let aide_encours=0;
    data?.transactions?.forEach((e:Transactions)=>{
        if (e.demande){
            if(e.demande.statut=='refuse'){
                return;
            }
            if(e.demande.statut=='paye'){
                aide_recue = aide_recue + e.montant;
            }else{
                aide_encours=aide_encours + e.montant;
            }
        }
    });
    chartbar.aide_recue   = -1* aide_recue;
    chartbar.aide_encours = -1* aide_encours;

    chartdata.push(chartbar);
    /*
    const usersColors=[
      "#a44e6f",
      "#7bb743",
      "#a25aca",
      "#61be84",
      "#ca49a1",
      "#407e44",
      "#6369c7",
      "#d09d3b",
      "#668fcc",
      "#cb542f",
      "#40bec1",
      "#d94568",
      "#89833b",
      "#ce8ac8",
      "#c97c5f"
    ];
    */
   

    return (
        error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : data ? (
        <div className="fond-chart">
            

            <BarChart width={550} height={500}
               
                //layout="vertical"
                data={chartdata}
                margin={{
                    top: 20,
                    right: 0,
                    left: 60,
                    bottom: 5,
                }}
                >
                <CartesianGrid   />
                <XAxis dataKey="name" />
                <YAxis width="auto"  />
                <Tooltip />
               {/*
               <YAxis width="auto" domain={[0,fond.objectif]} allowDataOverflow  />
                <ReferenceLine y={fond.objectif} label="Objectif" stroke="red" />
                 */}
                <Legend verticalAlign="top" height={36} align='left' width={"100%"} />

                       
                <Bar name={translate('fond_graph_recue')} dataKey="aide_recue" stackId="a" fill="#a44e6f"  />  
                <Bar name={translate('fond_graph_encours')}  dataKey="aide_encours" stackId="a" fill="#a25aca"  />  
                <Bar name={translate('fond_graph_disponible')}  dataKey="disponible" stackId="a" fill="#7bb743"  />  
            </BarChart>
        </div>
        ):null
  );
}

export default FondPersoBarChart;